/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { PanelButtonEdition } from '@mairistem/administres-utils';

import BlocChamps from './BlocChamps';
import type { SectionChamps } from './BlocChamps';

interface InformationsEvenementProps {
  identifiant?: number;
  /**
   * L'évènement se décrit depuis l'enfant pour une naissance, mais depuis
   * l'acte pour une reconnaissance : le composant reçoit donc les deux, et
   * c'est le descripteur du registre qui choisit sa source.
   */
  enfant?: any;
  /** L'évènement d'une reconnaissance est porté par l'acte. */
  acte?: any;
  /**
   * Individu principal du dossier (l'enfant, ou le DÉFUNT d'un décès).
   *
   * Nécessaire pour le décès : le lieu du décès est affiché dans ce bloc mais
   * stocké sur l'individu (`ai_dec_*`), sa modale doit donc pouvoir l'écrire.
   */
  individuPrincipal?: any;
  /** Endpoint générique des individus, transmis à la modale. */
  urlIndividus?: string;
  /** Rafraîchit l'individu principal quand la modale l'a modifié. */
  onIndividuSaved?: (individu: any) => void;
  /** Champs à afficher, produits par `FICHE_CONFIG[type].blocs.evenement`. */
  sections: SectionChamps[];
  /** Modale d'édition ; son absence rend le bloc en lecture seule. */
  Modal?: React.ComponentType<any>;
  service?: { update: (data: Record<string, any>) => Promise<any> };
  onSaved: (enfant: any) => void;
}

const InformationsEvenement = (props: InformationsEvenementProps) => {
  const {
    identifiant,
    enfant,
    acte,
    individuPrincipal,
    urlIndividus,
    sections,
    Modal,
    service,
    onSaved,
    onIndividuSaved,
  } = props;

  const [editing, setEditing] = React.useState(false);

  return (
    <div style={{ position: 'relative' }}>
      {Modal && <PanelButtonEdition onClick={() => setEditing(true)} />}
      {sections.map((section) => (
        <BlocChamps
          key={section.titre ?? 'evenement'}
          lignes={section.lignes}
          styleLigne={{ paddingRight: '2em' }}
        />
      ))}

      {Modal && (
        <Modal
          open={editing}
          identifiant={identifiant}
          enfant={enfant}
          acte={acte}
          /*
           * Trois noms pour la même valeur, chacun étant le contrat d'une
           * modale : `defunt` pour le lieu de décès, `individu` pour les modales
           * écrites depuis (le notaire du contrat de mariage).
           */
          defunt={individuPrincipal}
          individu={individuPrincipal}
          urlIndividus={urlIndividus}
          service={service}
          onClose={() => setEditing(false)}
          onSaved={onSaved}
          onIndividuSaved={onIndividuSaved}
        />
      )}
    </div>
  );
};

export default InformationsEvenement;
